export class AsociarDocumentoAEntidadRequest {
    public id_Documento: number = 0;
    public id_TipoEntidad: number =0;
    public id_Entidad: number=0;
}